import { BASE_URL } from '../../constants/api';
import Fetch from '../fetch';
import Store from '../../stores/Store';

import CacheService from '../../utils/CacheService';

import type {
  CityResponseType,
  SelectOptionType,
  CountryResponseType,
  ProvinceResponseType,
} from '../../types/types';

async function getCountry(): Promise<SelectOptionType[]> {
  const store = new Store();
  const token = store.get('token');

  const url = `${BASE_URL}/api/country/getAllCountry?token=${token}`;

  const json = await CacheService(
    'country/getAllCountry',
    async () => {
      const json = await Fetch<CountryResponseType[]>(
        url,
        {
          method: 'POST',
          headers: {
            'x-token': store.get('x-token'),
            'x-csrf': store.get('x-csrf'),
            accept: 'application/json',
          },
          body: JSON.stringify({}),
        },
        0
      );

      const findPh = json.find(item => item.countryName == 'Philippines');

      json.unshift(findPh);
      const countries = json.map(item => {
        return {
          code: item.id,
          value: item.countryName,
        };
      });
      return countries;
    },
    {
      expiry: 60 * 40,
    }
  );

  return json;
}

async function getProvince(country_id) {
  const store = new Store();
  const token = store.get('token');

  const url = `${BASE_URL}/api/state/getStateByCountry?token=${token}&countryId=${country_id}`;

  const json = await CacheService(
    `country/getStateByCountry/${country_id}`,
    async () => {
      const json = await Fetch<ProvinceResponseType[]>(
        url,
        {
          method: 'POST',
          headers: {
            'x-token': store.get('x-token'),
            'x-csrf': store.get('x-csrf'),
            accept: 'application/json',
          },
          body: JSON.stringify({}),
        },
        0
      );

      const province = json.map(item => {
        return {
          code: item.stateCode,
          value: item.stateName,
        };
      });

      return province;
    }
  );

  return json;
}

async function getCity(province_id) {
  const store = new Store();
  const token = store.get('token');

  const url = `${BASE_URL}/api/city/getCityByState?token=${token}&state=${province_id}`;

  const json = await CacheService(
    `city/getCityByState/${province_id}`,
    async () => {
      const json = await Fetch<CityResponseType[]>(
        url,
        {
          method: 'POST',
          headers: {
            'x-token': store.get('x-token'),
            'x-csrf': store.get('x-csrf'),
            accept: 'application/json',
          },
          body: JSON.stringify({}),
        },
        0
      );

      const cities = json.map(item => {
        return {
          code: item.id,
          value: item.cityName,
        };
      });
      return cities;
    }
  );

  return json;
}

export async function getOptionsAddress({
  category,
  param,
}: {
  category?: string;
  param?: string;
}): Promise<SelectOptionType[]> {
  let response = [];
  if (category == 'COUNTRY') {
    response = await getCountry();
    response[category] = response;
  } else if (category == 'PROVINCE') {
    response = await getProvince(param);
    response[category] = response;
  } else if (category == 'CITY') {
    response = await getCity(param);
    response[category] = response;
  }
  return category ? response[category] || [] : response;
}
